import { useNavigate } from "react-router-dom";
import backgroundVideo from "../assets/background_video.mp4";
import mokiLogo from "../assets/moki_logo.svg";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="flex relative min-h-screen flex-col items-left p-9 overflow-hidden">
      <video
        autoPlay
        loop
        muted
        playsInline
        className="absolute inset-0 -z-10 h-full w-full object-cover"
      >
        <source src={backgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="flex flex-col mt-12 items-left text-2xl font-extrabold text-black drop-shadow-lg">
        <img
          src={mokiLogo}
          alt="Moki Logo"
          className=" h-16 w-32 object-contain"
        />
        <p className="m-0">모키 데이터 센터에</p>
        <p className="m-0">오신 걸 환영합니다.</p>
      </div>

      <div className="fixed inset-x-4 bottom-16 flex flex-col items-center gap-4 rounded-xl bg-white/40 p-6 shadow-lg backdrop-blur">
        <button
          onClick={() => navigate("/login")}
          className="flex min-h-12 w-full flex-col items-center justify-center rounded-lg bg-black px-4 py-2 text-[4.2vw] font-semibold text-white active:scale-95"
        >
          📈 실시간 매출 분석 데이터 조회
          <span className="text-[3.4vw] font-normal text-gray-300">
            *점주님 전용
          </span>
        </button>

        <button
          onClick={() => navigate("/point")}
          className="min-h-[48px] w-full rounded-lg bg-black px-4 py-2 text-[4.2vw] font-semibold text-white active:scale-95"
        >
          💬 포인트 이용 내역 조회
        </button>
      </div>
    </div>
  );
}
